import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  AccountBalanceWallet as AccountBalanceWalletIcon,
  CompareArrows as CompareArrowsIcon,
  ReceiptLong as ReceiptLongIcon,
  VerifiedUser as VerifiedUserIcon,
  Home as HomeIcon,
  Restaurant as RestaurantIcon,
  Commute as CommuteIcon,
  LocalHospital as LocalHospitalIcon,
  Bolt as BoltIcon,
  School as SchoolIcon,
  ShoppingBag as ShoppingBagIcon,
  SportsEsports as SportsEsportsIcon,
  Savings as SavingsIcon,
  Favorite as FavoriteIcon,
  Category as CategoryIcon,
} from "@mui/icons-material";
import { TransactionCategoryIconKey } from "../../lib/transactionCategoryIcons";

interface CategoryIconBadgeProps {
  iconKey?: TransactionCategoryIconKey | null;
  size?: number;
}

const iconByKey: Record<TransactionCategoryIconKey, React.ReactNode> = {
  income: <AccountBalanceWalletIcon fontSize="inherit" />,
  transfer: <CompareArrowsIcon fontSize="inherit" />,
  tax: <ReceiptLongIcon fontSize="inherit" />,
  insurance: <VerifiedUserIcon fontSize="inherit" />,
  housing: <HomeIcon fontSize="inherit" />,
  food: <RestaurantIcon fontSize="inherit" />,
  transport: <CommuteIcon fontSize="inherit" />,
  health: <LocalHospitalIcon fontSize="inherit" />,
  utilities: <BoltIcon fontSize="inherit" />,
  education: <SchoolIcon fontSize="inherit" />,
  shopping: <ShoppingBagIcon fontSize="inherit" />,
  entertainment: <SportsEsportsIcon fontSize="inherit" />,
  finance: <SavingsIcon fontSize="inherit" />,
  lifestyle: <FavoriteIcon fontSize="inherit" />,
  category: <CategoryIcon fontSize="inherit" />,
};

const CategoryIconBadge: React.FC<CategoryIconBadgeProps> = ({
  iconKey,
  size = 16,
}) => {
  const theme = useTheme();
  const resolved = iconKey || "category";
  return (
    <Box
      component="span"
      sx={{
        width: size + 8,
        height: size + 8,
        borderRadius: "999px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size,
        bgcolor:
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.10)"
            : "rgba(0,0,0,0.08)",
        color: "text.primary",
        border:
          theme.palette.mode === "dark"
            ? "1px solid rgba(255,255,255,0.18)"
            : "1px solid rgba(0,0,0,0.10)",
      }}
    >
      {iconByKey[resolved]}
    </Box>
  );
};

export default CategoryIconBadge;
